import { render, staticRenderFns } from "./SalesList.vue?vue&type=template&id=6b58bb40&scoped=true&"
import script from "./SalesList.vue?vue&type=script&lang=ts&"
export * from "./SalesList.vue?vue&type=script&lang=ts&"
import style0 from "./SalesList.vue?vue&type=style&index=0&id=6b58bb40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b58bb40",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VCol,VRow,VSubheader})
